import { render, staticRenderFns } from "./FunctionBox.vue?vue&type=template&id=30108dd8&scoped=true&"
import script from "./FunctionBox.vue?vue&type=script&lang=ts&"
export * from "./FunctionBox.vue?vue&type=script&lang=ts&"
import style0 from "./FunctionBox.vue?vue&type=style&index=0&id=30108dd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30108dd8",
  null
  
)

export default component.exports